import { render, staticRenderFns } from "./ItemListHomeVideoLayout.vue?vue&type=template&id=bab504f8&scoped=true&"
import script from "./ItemListHomeVideoLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListHomeVideoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab504f8",
  null
  
)

export default component.exports